import { z } from "zod";

// --- Frontmatter schema ---

const AuthorSchema = z.object({
	name: z.string(),
	avatar: z.string().optional(),
	bio: z.string().optional(),
});

const HeroImageSchema = z.object({
	src: z.string(),
	alt: z.string(),
	credit: z.string().optional(),
});

const CategoryEnum = z.enum([
	"word-deep-dive",
	"slang-roundup",
	"culture-language",
	"contributor-spotlight",
]);

export const FrontmatterSchema = z.object({
	title: z.string().min(1),
	description: z.string().min(50).max(200),
	date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
	updated: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
	tags: z.array(z.string()).min(1),
	author: AuthorSchema,
	heroImage: HeroImageSchema.optional(),
	category: CategoryEnum,
	featured: z.boolean().default(false),
	draft: z.boolean().default(false),
});

export type Frontmatter = z.infer<typeof FrontmatterSchema>;
export type Category = z.infer<typeof CategoryEnum>;

// --- Types ---

export interface BlogPost {
	slug: string;
	frontmatter: Frontmatter;
	code: string;
	readingTime: { text: string; minutes: number; words: number };
}

export interface BlogPostListItem {
	slug: string;
	frontmatter: Frontmatter;
	readingTime: { text: string; minutes: number };
}

// --- Constants (safe for client) ---

export const CATEGORY_LABELS: Record<Category, string> = {
	"word-deep-dive": "Word Deep Dive",
	"slang-roundup": "Slang Roundup",
	"culture-language": "Culture & Language",
	"contributor-spotlight": "Contributor Spotlight",
};
